<template>
  <div class="col-md-12 ">
    <div class="promotionCard" style="">
      <div class="row" style="align-items: center;justify-content: center;gap: 1rem;">
        <div class="col-12 col-sm-3 ">
          <img
            v-if="item.product.catalogImage"
            :data-src="item.product.catalogImage.path"
            :alt="item.product.title"
            class="lazyload img-fluid"
          >
        </div>

        <div class="product-description row col-12 col-sm-9" style="gap: 1rem;cursor:pointer;" @click="navigateToProduct(item);
">
          <div class="col-12 col-sm-8">
            <div>
              <span v-if="item.product.isNewFormula" class="badge badge-primary">Nouvelle formule</span>
              <span v-if="item.product.isNew" class="badge badge-primary">Nouveauté</span>
              <span v-if="item.product.bestSales" class="badge badge-primary">Meilleures ventes</span>
              <span v-if="item.product.provenSatisfaction" class="badge badge-primary">Satisfaction prouvée</span>
              <span v-if="item.product.provenEffectiveness" class="badge badge-primary">Efficacité prouvée</span>
            </div>

            <div>
              <strong>
                <span v-if="item.name">{{ item.name }} -</span>
                {{ item.product.title }}
              </strong>
            </div>



            <div>
              Réf. {{ item.id }}
            </div>


            <div class="prix" >
              <span style="font-weight: bold;">{{ (item.discountedPrice > 0 ? item.discountedPrice : item.price) | moneyFormat }}</span>
              <del v-if="item.discountedPrice > 0">
                {{ item.price | moneyFormat }}
              </del>
            </div>
          </div>

          <div class="col-12 col-sm-4">
<!--            <div class="">-->
<!--              <ponroy-cart-quantity :hasLabel="false" buttonType="button" v-model="quantity"></ponroy-cart-quantity>-->
<!--            </div>-->

            <div class="">
              <button @click.prevent.stop="submit()" type="button" class="btn btn-primary">Ajouter au panier</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.promotionCard {
  border-radius: 0.5rem;
  overflow: hidden;margin-bottom: 1rem;
  box-shadow: 0 0 5px 0 rgba(119, 135, 129, 0.15);
  -webkit-box-shadow: 0 0 5px 0 rgba(119, 135, 129, 0.15);
  -moz-box-shadow: 0 0 5px 0 rgba(119, 135, 129, 0.15);
  border: 1px solid #f0f3f2;

  .product-description {
    padding: 1rem;
  }

  .badge-primary {
    color: white;
    background: #ff645d;
  }
}

  @media (max-width: 576px) {
    .promotionCard {


      text-align: center;
      img {
        max-width: 150px;
      }

    .product-description {
      justify-content: center;
    }
      button {
        margin-bottom: 1rem;
      }
    }
  }


</style>

<script>

import {mapState, mapActions, mapGetters} from 'vuex';
import CartQuantity from './CartQuantity.vue';


const CartRecommendation = {
  name: 'ponroy-cart-recommendation',
  components: {
    CartQuantity,
  },
  props: {
    repository: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    reference: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      orderable: {
        repository: this.repository,
        id: null,
      },
      quantity: 1,
    }
  },

  methods: {
    ...mapActions('cart', [
      'addToCart',
    ]),
    async submit() {
      const {quantity} = this;

      this.addToCart({
        orderable: {
          repository: this.repository,
          id: this.reference.toUpperCase()
        },
        'quantity': quantity
      });

      this.quantity = 1;

      // window._ebq = window._ebq || [];
      // window._ebq.push(['trackActivity', {
      //   original_id: this.reference,
      //   verb: 'click-on-reco',
      //   type: 'product',
      //   widgetId: '5b17a68d3b825051aa1da7ba'
      // }]);
    },
    navigateToProduct(item) {
      window.location.href = Routing.generate('site_product_show', { 'id': item.product.id, 'slug': item.product.slug });
    },
  },
};

export default CartRecommendation;
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/CartRecommendation.vue